import { BaseService } from "./BaseService";

export class ReservationService extends BaseService {
  constructor() {
    super("/reservations"); // Pass the base URL for the school endpoints
  }

  async findByAvailability(weekday) {
    if (this.apiBaseUrl) {
      try {
        const response = await this.getClient().get(
          `${this.baseUrl}/weekday/${weekday}`
        );
        return response.data;
      } catch (error) {
        this.handleError(error);
      }
    } else {
      return this.simulateLocalStorageRead({});
    }
  }

  async getMonthlyAvailability(options = {}) {
    try {
      const response = await this.getClient().get(
        `${this.baseUrl.replace('reservations', 'schools')}/availability/monthly`,
        { params: options }
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getAvailableSchoolsForDate(date) {
    try {
      const response = await this.getClient().get(
        `${this.baseUrl.replace('reservations', 'schools')}/availability/date/${date}`
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  // Add a new reservation for the logged-in user
  async addReservation(reservation) {
    console.log("addReservation", reservation);
    try {
      const response = await this.getClient().post(
        `/reservations`,
        reservation
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  // Fetch all reservations for the logged-in user
  async getReservations() {
    try {
      const response = await this.getClient().get(`/reservations`, {
        params: { pagination: false }
      });
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getReservationHistory() {
    try {
      const response = await this.getClient().get(`/reservations/history`);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async cancelReservation(reservationId, note = "", colleagueRegistration = "") {
    try {
      console.log({ reservationId, note, colleagueRegistration });
      const response = await this.getClient().post(
        `/reservations/${reservationId}/cancel`,
        { note, colleagueRegistration }
      );
      console.log(response.data, response.status);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async checkin(reservationId, coordinates) {
    try {
      console.log({ reservationId, coordinates });
      const response = await this.getClient().patch(
        `/reservations/${reservationId}/checkin`,
        coordinates
      );
      console.log(response.data, response.status);
      return response.data;
    } catch (error) {
      console.error("Checkin error:", error);
      // Don't call handleError as it throws, just return error object
      return { error: true, message: error?.response?.data?.message || error.message };
    }
  }

  async checkout(reservationId) {
    try {
      console.log({ reservationId });
      const response = await this.getClient().patch(
        `/reservations/${reservationId}/checkout`
      );
      console.log(response.data, response.status);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getCanceledReservations() {
    try {
      const response = await this.getClient().get("/reservations/canceled");
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getAvailableSlots(schoolId, date) {
    try {
      const response = await this.getClient().get(
        `/reservations/available-slots/${schoolId}`,
        { params: { date } }
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }
}
